import { Component } from 'react';
import CookieConsent from "react-cookie-consent";

class Footer extends Component {
    render() {
        return (

            <footer>
                <div className="footer">
                    <div className="container">
                        <div className="row text-center text-xs-center text-sm-left text-md-left">
                            <div className="col-xs-12 col-sm-3 col-md-3">
                                <h5>{this.props.contact.title}</h5>
                                <p>
                                    {this.props.contact.email.key} : <a href={"mailto:info@coeladvocaten.be?subject=*CONTACT via www.coeladvocaten.be"} alt="contact">{this.props.contact.email.value}</a>
                                
                                    {
                                        this.props.contact.lines.map((line, index) =>
                                            <span key={index}>{line.text}<br /></span>
                                        )
                                    }
                                </p>
                            </div>
                            <div className="col-xs-12 col-sm-3 col-md-3">
                                <h5>{this.props.info.title}</h5>
                                <p>
                                    {
                                        this.props.info.lines.map((line, index) =>
                                            <span key={index}>{line.text} <br /></span>
                                        )
                                    }
                                </p>
                            </div>
                            <div className="col-xs-12 col-sm-3 col-md-3">
                                <h5>{this.props.links.title}</h5>
                                <ul className="list-unstyled quick-links">
                                    {
                                        this.props.links.items.map((item, index) =>
                                            <li key={index}><a href={item.url}><i className="fa fa-angle-double-right"></i>{item.name}</a></li>
                                        )
                                    }
                                </ul>
                            </div>
                            <div className="col-xs-12 col-sm-3 col-md-3">
                                <h5>{this.props.articles.title}</h5>
                                <ul className="list-unstyled quick-links">
                                    {
                                        this.props.articles.items.map((item, index) =>
                                            <li key={index}><a href={item.url}><i className="fa fa-angle-double-right"></i>{item.name}</a></li>
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-5">
                                <ul className="list-unstyled list-inline social text-center">
                                <li className="list-inline-item"><a target="_blank" href="https://www.facebook.com/pages/category/Criminal-Lawyer/Coel-Advocaten-665996920220752/"><i className="fa fa-facebook"></i></a></li>
                                    <li className="list-inline-item"><a target="_blank" href="https://www.linkedin.com/company/coel-advocaten/"><i className="fa fa-linkedin"></i></a></li>
                                    <li className="list-inline-item"><a target="_blank" href="https://www.youtube.com/channel/UCP8baTr6nRmG6uHPqpczpFA"><i className="fa fa-youtube"></i></a></li>
                                </ul>
                            </div>
                            <hr />
                        </div>	
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-2 text-center">
                                <p>
                                    <a href={this.props.condition.url}>{this.props.condition.name}</a>&nbsp;/&nbsp;
                                    <a href={this.props.privacy.url}>{this.props.privacy.name}</a>
                                </p>
                                <p>&copy; {this.props.copyright}</p>
                                <p><a target="_blank" href={this.props.designer.url} alt={this.props.designer.alt}>{this.props.designer.name}</a></p>
                            </div>
                        </div>	
                    </div>

                    <div className="cookies">
                        <CookieConsent
                            location="bottom"
                            buttonText={this.props.cookies.button} 
                            cookieName="coeladvocaten-cookie"
                            style={{ background: "#FBCB3B", textAlign:"center", color:"#000000", fontWeight: "bolder" }}
                            buttonStyle={{ background: "#000000", fontSize: "15px", color: "#FFFFFF" }}
                            expires={150}
                        >
                            {this.props.cookies.text} | <a href={this.props.cookies.url} alt={this.props.cookies.name}>{this.props.cookies.name}</a>
                        </CookieConsent>  
                    </div>
                </div>
            </footer>
        );

    }
}

export default Footer